// extracted by mini-css-extract-plugin
export default {"root":"yes_no-module___root___f0961660","yes":"yes_no-module___yes___f9a66658"};